/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const currentYear = new Date().getFullYear();

  return (
    <Segment role="contentinfo" padded id="footer">
      <div className="footerTop">

        <div className='logoWhiteDiv'>
          <img src='../Logo_Lettering.svg' alt='Logo White' className='logoWhite' />
        </div>

        <div>
          <List className="footerList">
            <div role="listitem" className="item">
              <p className="item">
                <FormattedMessage
                  id="Footer-Name"
                  defaultMessage="Patrick Rettenmund"
                />
              </p>
            </div>
            <div role="listitem" className="item">
              <p className="item">
                <FormattedMessage
                  id="Footer-Adresse"
                  defaultMessage="Eyfuhrenweg 42"
                />
              </p>
            </div>
            <div role="listitem" className="item">
              <p className="item">
                <FormattedMessage
                  id='Footer-Plz-Ort'
                  defaultMessage="3437 Rüderswil"
                />
              </p>
            </div>
          </List>
        </div>
        
        <div>
          <List className="footerList">
            <div role="listitem" className="item">
              <i className="ri-phone-line"></i>
              <a className="item" href="tel:079 323 73 31">
                <FormattedMessage
                  id='Footer-Telefon'
                  defaultMessage="079 323 73 31"
                />
              </a>
            </div>
            <div role="listitem" className="item">
              <i className="ri-mail-line"></i>
              <a className="item" href="mailto:info@patrick-rettenmund.ch">
                <FormattedMessage
                  id='Footer-Email'
                  defaultMessage="info@patrick-rettenmund.ch"
                />
              </a>
            </div>
          </List>
        </div>
      </div>
      <hr/>
      <div className='footerBottom'>
        <div>
          <List className="footerList">
            <div role="listitem" className="item">
              <a className="item" href="./impressum">
                <FormattedMessage
                  id='Footer-Imprint'
                  defaultMessage="Impressum"
                />
              </a>
            </div>
            <div role="listitem" className="item">
              <a className="item" href="./datenschutz">
                <FormattedMessage
                  id='Footer-privacy'
                  defaultMessage="Datenschutzerklärung"
                />
              </a>
            </div>
            <div role="listitem" className="item">
              <a className="item" href="./AGB">
                <FormattedMessage
                  id='Footer-AGB'
                  defaultMessage="AGB"
                />
              </a>
            </div>
            <div role="listitem" className="item">
              <i className="ri-copyright-line"></i>
              {currentYear}&nbsp;
              <FormattedMessage
                id='Footer-Copyright'
                defaultMessage="Patrick Rettenmund"
              />
            </div>
          </List>
        </div>
      </div>
    </Segment>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
